import { Controller } from "@hotwired/stimulus"

// Switches the four panels of the allowance editor.
//
// Panels are only hidden, never removed: field_editor_controller builds the save
// payload by reading every input in the card, so a detached panel would drop its
// fields silently. The red dots mark tabs whose validation errors came back from
// a rejected save.
const ACTIVE = ["border-green-500", "text-green-600"]
const INACTIVE = [
  "border-transparent",
  "text-gray-500",
  "hover:text-gray-700",
  "hover:border-gray-300",
]

export default class extends Controller {
  static targets = ["tab", "panel", "dot"]
  static values = {
    currentTab: { type: String, default: "calculation" },
    errorTabs: { type: Array, default: [] },
  }

  connect() {
    this.showTab(this.currentTabValue)
  }

  switch(event) {
    this.showTab(event.currentTarget.dataset.tab)
  }

  showTab(tabName) {
    this.currentTabValue = tabName

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName
      tab.classList.remove(...(isActive ? INACTIVE : ACTIVE))
      tab.classList.add(...(isActive ? ACTIVE : INACTIVE))
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panel !== tabName)
    })

    // "hidden" and "inline-block" are both display utilities, so the dot must
    // carry exactly one of them — leaving inline-block on a hidden dot makes it
    // visible again depending on stylesheet order.
    this.dotTargets.forEach((dot) => {
      const hasError = this.errorTabsValue.includes(dot.dataset.tab)
      dot.classList.toggle("hidden", !hasError)
      dot.classList.toggle("inline-block", hasError)
    })
  }
}
